<template>
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-output-icon01.svg" alt="*" />あなたのアウトプット性質
					</span>
				</div><!-- end .type -->
				<div class="cover">
					創出型{{outputResult.percentageLeft}}%、操縦型{{outputResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>現状のアウトプット習慣をシフトチェンジすることで、自分の個性をより生かした世界で輝くことができる</h2>
				<img src="../assets/result-detail-output-outleft01.svg" alt="*" class="visual" />
				<div class="caption">
					あなたは創造的なアウトプットの経験値は高いが、実際の創造力に結び付きづらい傾向にある
				</div><!-- end .caption -->
				<p>この項目では、あなたのアウトプットの経験値や能力について検査しました。人生は何をアウトプットするかで決まるといっても過言はありません。私たちは自分たちが合うプットしたものを価値に変えて生活しています。</p>
				<p>診断の結果、あなたは非常に創造的なアウトプットの経験が豊かであることが分かりました。クリエイティブなことに関する興味関心が強く、自分のアイデアをどんどん形にしています。</p>
				<p>ただし、あなたにはもっと自分に向いているアウトプットの内容と方法があり、これからは今までとは違うベクトルでアウトプットの努力を積み重ねるべきだと診断することもできます。自分の外向性に合ったアウトプットに注目し、努力を重ねることで、あなたはよりスムーズな成功や成長を手にすることができるようになります。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>アウトプットの内容と質に注目すれば、自分自身の価値はまだまだ上昇する</h2>
				<img src="../assets/result-detail-output-outleft02.svg" alt="*" class="visual" />
				<div class="caption">
					あなたは、人との対話、身体を使う運動や表現など、外へエネルギーを放出するアウトプットに適性がある
				</div><!-- end .caption -->
				<p>外向度のスコアが高いあなたは、対人関係におけるアウトプットが非常に得意です。異業種交流会などに繰り出し、よりよいビジネスパートナーを開拓するなど、「人にまつわる」アウトプットにとても大きな適性があります。</p>
				<p>一方で、深い専門性や精神性の高いアウトプットは苦手な傾向があります。専門分野や精神性に深く入り込むことは、非常に「内へ向く」行為だからです。あなたは内へ深く踏み込む前に、外へエネルギーを放出したくなるでしょう。</p>
				<p>クリエイティブやアートにおけるアウトプットでは、内向型の人よりも軽薄になりがちです。深い文章を書いたり、深みのある言葉で語ったりは、あなたが想っている以上に、あなたは苦手です。しかし、ポップなエンターテインメントでは、外向的な人の活躍の場もかなり用意されています。</p>
				<p>外向型でアウトプットが操縦型のあなたは、外見や身体を使うような表現では勝負ができます。あなたはパフォーマーのようなアウトプットが合っているようです。アスリートやダンサー、ミュージシャンは、高い外向性と多くのアウトプットが必要なので、あなたは他のタイプよりも早く成長できる可能性があります。</p>
				<p>外向型の人のアウトプットは「情熱」といったロジックに収まらない感情を乗せていくほうが、良い結果が望めます。「人にまつわる」アウトプットにとても大きな適性があるのもこのためです。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>ゴールのためにやるべきことを明確に定めてアウトプットするべし</h2>
				<img src="../assets/result-detail-output-outleft03.svg" alt="*" class="visual" />
				<div class="caption">
					現在の創出型とは真逆のアウトプット体質を持つほうが、あなたの才能が開花されやすい
				</div><!-- end .caption -->
				<p>あなたの現在のアウトプットは「創出型」タイプでしたが、真逆の「操縦型」のほうが、物事がうまく運びやすいと言えます。操縦型とは、マニュアルやルールのあるアウトプットに傾倒するタイプです。</p>
				<p>外向型は、アウトプットも一直線に向かうことが好ましいと言えます。その都度、複雑な内省を求められる分野は、内向度が高い人間に太刀打ちできないからです。</p>
				<p>ゴールに向かって、明確なノウハウや手法を見つけること、これこそが、外向型がアウトプットで栄光を勝ち取る最良の選択と言えます。</p>
				<p>専門家や先輩からアドバイスを受ける際も、「最低これだけはやっておけ」「とりあえずこの順番でやれば大丈夫！」といった具体的な手法のみをシンプルに聞き出すようにしましょう。具体的なアクションをもらうことにケチにならずに、時にはある程度の大きなお金を払ってでも、具体的な対策やノウハウを手に入れたいものです。</p>
				<p>そして、いったんは素直に受け入れ、そのまま行動に移す、こういったマインドセットも非常に大切です。外向型で創出型の人は、自分のアイデアやセンスを過大評価している節があり、周囲の認識と大きなギャップを生んで、失敗を招きやすいからです。</p>
				<p>外向型のタイプは、悩むことや考え込むことが単なる時間の無駄ことが多いため、やるべきことだけを抽出することで、時間を有意義に使えるようになります。</p>
				<p>自分が常に具体的であるか、抽象度の高い枠に収まっていないかをセルフチェックし、過ごしていくだけでも、一つ一つのアウトプットの質が高まります。そして、あなたのアウトプットに多くの人が恩恵を受け、あなたも周囲から多くのものを与えられるようになるでしょう。</p>
			</div><!-- end .sentence -->
		</div><!-- end .contents -->			
</template>

<script>


export default {
	name: 'ResultDetailOutputOutLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
